"use client";

import { useStytchB2BClient } from "@stytch/nextjs/b2b";
import { jwtDecode } from "jwt-decode";
import { useEffect, useRef } from "react";

function readCookie(name: string): string | undefined {
  if (typeof document === "undefined") {
    return undefined;
  }
  const nameEQ = `${name}=`;
  const parts = document.cookie.split(";");
  for (const part of parts) {
    const trimmed = part.trim();
    if (trimmed.startsWith(nameEQ)) {
      return decodeURIComponent(trimmed.substring(nameEQ.length));
    }
  }
  return undefined;
}

export function useStytchMemberSessionGuard(): void {
  const stytch = useStytchB2BClient();
  const attemptedRef = useRef(false);

  useEffect(() => {
    if (attemptedRef.current) {
      return;
    }
    attemptedRef.current = true;

    try {
      const sessionJwt = readCookie("stytch_session_jwt");
      if (!sessionJwt) {
        return;
      }

      let subject: string | undefined;
      try {
        const payload = jwtDecode<{ sub?: string }>(sessionJwt);
        subject = payload?.sub;
      } catch (_err) {
        // If the JWT cannot be decoded, treat it as invalid
        subject = undefined;
      }

      const isB2BMember =
        typeof subject === "string" && subject.startsWith("member-");
      if (!isB2BMember) {
        // Best-effort revoke; ignore errors
        stytch?.session.revoke({ forceClear: true }).catch(() => undefined);
      }
    } catch (_e) {
      // no-op
    }
  }, [stytch]);
}

export function StytchMemberSessionGuard() {
  useStytchMemberSessionGuard();
  return null;
}
